import React from 'react';


export const EmptyStar = () => (
  <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FEC41F" fillRule="evenodd"
      d="M20.641 20.2a3 3 0 0 1 .81-2.572l3.479-3.579-4.667-.715a3 3 0
      0 1-2.262-1.695L16 7.361l-2 4.278a3 3 0 0 1-2.263 1.695l-4.667.715 3.479 3.579a3 3 0
      0 1 .81 2.572l-.8 4.925 3.985-2.212a3 3 0 0 1 2.911 0l3.986 2.212-.8-4.925zm-5.126 4.462l-5.79 3.212a1 1 0
      0 1-1.471-1.035l1.13-6.96a1 1 0 0 0-.27-.857l-4.83-4.97a1 1 0 0 1 .565-1.685l6.584-1.01a1 1 0 0
      0 .755-.565l2.906-6.215a1 1 0 0 1 1.812 0l2.906 6.215a1 1 0 0 0 .754.565l6.585 1.01a1 1 0
      0 1 .565 1.685l-4.83 4.97a1 1 0 0 0-.27.857l1.13 6.96a1 1 0
      0 1-1.472 1.035l-5.789-3.212a1 1 0 0 0-.97 0z" />
  </svg>
);

export const FilledStar = () => (
  <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FEC41F" fillRule="evenodd" d="M15.515 24.675l-5.807 3.221a1 1 0 0 1-1.472-1.035l1.134-6.98a1
    1 0 0 0-.27-.857L4.255 14.04a1 1 0 0 1 .565-1.686l6.604-1.013a1 1 0 0 0 .755-.564l2.915-6.234a1 1 0 0 1 1.812
      0l2.915 6.234a1 1 0 0 0 .754.564l6.605 1.013a1 1 0 0 1 .565 1.686L22.9 19.024a1 1 0 0 0-.27.857l1.134 6.98a1
      1 0 0 1-1.472 1.035l-5.807-3.221a1 1 0 0 0-.97 0z" />
  </svg>
);
